<template>
  <div class="join">
    <div class="top">
      <img src="http://video.naolamp.com/officialWeb/about/join_1.jpg"/>
    </div>
    <div class="content">
      <el-tabs v-model="activeName2" type="card" @tab-click="handleClick()">
        <el-tab-pane label="加盟门店" name="first">
          <div class="title">
            <h4>申请为零售经销商</h4>
            <p>请仔细填写下文卷表格</p>
          </div>
          <div class="two">
            <el-col :span="24">
              <el-input v-model="name" placeholder="请输入您的名字"></el-input>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="24">
              <el-input v-model="company" placeholder="请输入您的工作单位"></el-input>
            </el-col>
          </div>
          <div class="select" style="margin-top: 42px;">
            <el-select v-model="province" placeholder="请选择省份" @change="changeProvince(province, 2)">
              <el-option
                v-for="item in options"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaName">
              </el-option>
            </el-select>

            <el-select v-model="city" collapse-tags style="margin-left: 20px;"
              placeholder="请选择城市" @change="changeProvince(city, 3)">
              <el-option
                v-for="item in optionsCity"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaName">
              </el-option>
            </el-select>
            <el-select
              v-model="area"
              collapse-tags
              style="margin-left: 20px;"
              placeholder="请选择区域">
              <el-option
                v-for="item in optionsArea"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaName">
              </el-option>
            </el-select>
          </div>
          <div class="two">
            <el-col :span="24">
              <el-input v-model="address" placeholder="请输入您的详细地址"></el-input>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="24">
              <el-input v-model="tel" placeholder="请输入您的办公电话"></el-input>
            </el-col>
          </div>
          <div class="two">
            <el-col :span="24">
              <el-input v-model="phone" placeholder="请输入您的移动电话" maxlength="11"></el-input>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="24">
              <el-input v-model="email" placeholder="请输入您的邮箱"></el-input>
            </el-col>
          </div>
          <el-input
            style="margin-top: 42px;"
            type="textarea"
            :rows="2"
            placeholder="请输入当前职业/主营业务详细描述"
            v-model="busDetail">
          </el-input>
          <el-input
            style="margin-top: 42px;"
            type="textarea"
            :rows="2"
            placeholder="如果您公司拥有分销网络，请注明公司所属店铺数量"
            v-model="storeDetail">
          </el-input>
          <div class="active">
            <p>您之前是否拥有经营过汽车膜相关业务？</p>
            <el-radio v-model="hasExp" label="Y">是</el-radio>
            <el-radio v-model="hasExp" label="N">否</el-radio>
          </div>
          <button @click="submit" class="submit">提交</button>
        </el-tab-pane>
        <el-tab-pane label="职位招聘" name="second">
          <div class="box">
            <div class="item">
              <h4>产品经理</h4>
              <div class="illustrate">
                <p>岗位职责：</p>
                <br>
                <p>1、负责公司客户端产品功能与交互设计；</p>
                <br>
                <p>2、负责用户需求分析，寻找用户痛点，回执流程图、原型稿、撰写PRD文档；输出产品demo;</p>
                <br>
                <p>3、负责项目的合作沟通和项目执行推进，实现产品的上线与迭代；</p>
                <br>
                <p>4、负责产品上线后的持续跟进及日常运营工作。</p>
              </div>
              <div class="claim">
                <p>任职要求：</p>
                <br>
                <p>1、本科及以上学历，有2-3年的产品策划经验；</p>
                <br>
                <p>2、至少一个成功产品经验；</p>
                <br>
                <p>3、有较好的用户需求分析能力，以及产品交互设计基础，熟练的使用Axure等原型工具；</p>
                <br>
                <p>4、有良好的沟通能力与团队协作能力；能独立跟进项目，多方协调完成项目；</p>
                <br>
                <p>5、有过运营支撑系统设计优先。</p>
              </div>
            </div>
            <div class="item">
              <h4>Java开发工程师</h4>
              <div class="illustrate">
                <br>
                <p>岗位职责：</p>
                <br>
                <p>1、根据公司发展要求，进行Web APP项目开发及维护；</p>
                <br>
                <p>2、负责后台管理平台开发，整体架构设计，及后端功能开发；</p>
                <br>
                <p>3、参与需求评审、设计评审、与产品、设计、客户端、前端开发人员紧密协作、主动沟通、解决难题；</p>
                <br>
                <p>4、收集用户反馈，分析用户行为及需求，对产品进行持续的优化和改进。</p>
                <!--<br>-->
                <!--<p></p>-->
                <!--<br>-->
                <!--<p></p>-->
              </div>
              <div class="claim">
                <p>任职要求：</p>
                <br>
                <p>1、全日制本科以上学历，4年及以上大中型应用产品软件开发经验，有相关互联网产品应用开发经验；</p>
                <br>
                <p>2、 理解软件系统架构，熟悉面向对象分析设计方法，有较强的逻辑能力，具有OOA、OOD、OOP以及UML建模经验；</p>
                <br>
                <p>3、熟悉掌握Struts2、Spring、Hessian、Thrift、ibatis、Shiro、Hibernate、Xlightweb,有Mina、Netty等项目使用经验优先；</p>
                <br>
                <p>4、熟练使用数据库如Mysql、MSSQL等，具有SQL优化经验者优先；</p>
                <br>
                <p>5、能使用Linux、Unix操作系统常用相关命令；</p>
                <br>
                <p>6、有较强的分析问题和解决问题的能力；</p>
                <br>
                <p>7、有良好的软件工程知识和质量意识；</p>
                <br>
                <p>8、有较强的逻辑思维能力，对技术有强烈的兴趣，具有良好的学习能力；</p>
                <br>
                <p>9、有良好的沟通能力和代码编写规范习惯；</p>
                <br>
                <p>10、工作认真负责，能承受工作压力，具备良好的沟通能力和团队合作意识。</p>
              </div>
            </div>
            <div class="item">
              <h4>HTML5前端开发工程师</h4>
              <div class="illustrate">
                <br>
                <p>岗位职责：</p>
                <br>
                <p>1、移动设备（手机,ipad）上的html5 ,css3 前端开发工作；</p>
                <br>
                <p>2、JavaScript程序模块开发，通用类库、框架编写；</p>
                <br>
                <p>3、利用移动跨平台框架(JqueryMobile,Zepto)j进行移动端脚本开发；</p>
                <br>
                <p>4、对前端开发技术框架进行评估与规范化,产品化,并制定相关的技术规范。</p>
              </div>
              <div class="claim">
                <p>任职要求：</p>
                <br>
                <p>1、熟悉javascript脚本开发并做到多浏览器兼容；</p>
                <br>
                <p>2、精通html5,css3,可高效手写代码；</p>
                <br>
                <p>3、熟悉至少一种后台开发语言(如.net ,java)；</p>
                <br>
                <p>4、必须要有适配手机端网页经验；</p>
                <br>
                <p>4、研究并使用过JqueryMobile,ZeptoJS，iwebkit,nodejs等移动框架中的一种或以上</p>
              </div>
            </div>
            <div class="item">
              <h4>安卓开发</h4>
              <div class="illustrate">
                <p>岗位职责：</p>
                <br>
                <p>1、根据需求不断修改完善公司的安卓项目；</p>
                <br>
                <p>2、能够根据后台提供的接口数据完成安卓前端工作,并能够根据后台的数据格式提出自己合理的意见完善接口；</p>
                <br>
                <p>3、具有良好的设计模式和思维及具备良好的沟通能力,以及较强的解决问题的能力。</p>
              </div>
              <div class="claim">
                <p>任职要求：</p>
                <br>
                <p>1、大专以上学历,1年以上工作经验；</p>
                <br>
                <p>2、熟悉Android四大组件及其生命周期；</p>
                <br>
                <p>3、熟悉ActivityManagerService、WindowManagerService、PackageManagerService其中至少一种；</p>
                <br>
                <p>4、熟悉多线程，了解并发、异步常识；</p>
                <br>
                <p>5、熟悉网络编程，及Json、XML等数据传输常用格式；</p>
                <br>
                <p>6、熟悉Android Studio IDE,熟悉基本框架1-2两个，如EventBu；
                  s，Gson，GreenDAO，Picasso等；</p>
                <br>
                <p>7、了解RxJava+Retrofit响应式框架；</p>
                <br>
                <p>8、能够融入团队协作完成APP项目开发；</p>
                <br>
                <p>9、求知欲强,有一颗不断完善自我的热忱的心。</p>
              </div>
            </div>
            <div class="item">
              <h4>IOS开发</h4>
              <div class="illustrate">
                <p>岗位职责：</p>
                <br>
                <p>1、负责 IOS手机客户端的设计和开发；</p>
                <br>
                <p>2、负责根据UI设计图进行IOS手机客户端软件的封装；</p>
                <br>
                <p>3、负责根据其他开发组提供的数据接口进行数据交互；</p>
                <br>
                <p>4、负责客户端产品的架构设计，分析和发现系统的优化点；</p>
                <br>
                <p>5、负责软件代码的编写、调试及后期维护；</p>
                <br>
                <p>6、参与相关产品技术文档或项目方案文档编写；</p>
                <br>
                <p>7、完成领导安排的紧急任务，配合其他同事共同完成。</p>
              </div>
              <div class="claim">
                <p>任职要求：</p>
                <br>
                <p>1、全日制本科以上学历，1年以上IOS相关开发经验，计算机相关专业；</p>
                <br>
                <p>2、精通Objective-C语言,精通iOS框架，熟悉xcode开发环境；</p>
                <br>
                <p>3、熟练使用iphone/ipad SDK及相关开发工具，掌握IOS平台上app开发，能独立完成中小型软件的系统开发优先；</p>
                <br>
                <p>4、熟悉HTML5最新规范，能够熟练运用HTML5特性构建移动端的WebApp，了解各种浏览器兼容性；</p>
                <br>
                <p>5、深刻理解网络通讯原理，有实际的网络通讯开发经验；熟悉 WebService、 Socket 等网络通信编程技术；
                  熟悉单元测试与集成测试；</p>
                <br>
                <p>6、较强的程序调试能力，熟悉性能化的工具和方法。</p>
              </div>
            </div>
            <div class="item">
              <h4>UI设计师</h4>
              <div class="illustrate">
                <p>岗位职责：</p>
                <br>
                <p>1、负责互联网、移动终端的产品线的整体风格及定位；</p>
                <br>
                <p>2、配合产品经理和开发人员进行相应的页面制作；</p>
                <br>
                <p>3、参与制定设计体验、流程和设计规范，并能够清晰表达自己的设计理念；</p>
                <br>
                <p>4、有互联网、移动应用视野与时尚的审美标准；</p>
                <br>
                <p>5、可建立整体的视觉体系；</p>
                <br>
                <p>6、熟练使用Photoshop和AI、DW、、flash、illustrator等2种相关设计软件。</p>
              </div>
              <div class="claim">
                <p>任职要求：</p>
                <br>
                <p>1、全日制本科以上学历，美术、计算机、视觉、设计等相关专业优先；</p>
                <br>
                <p>2、要求一年以上工作经验；</p>
                <br>
                <p>3、熟悉photoshop、coreldraw、Dreamweaver、AI、Flash等软件操作。</p>
              </div>
            </div>
            <div class="item">
              <h4>销售代表</h4>
              <div class="illustrate">
                <p>岗位职责：</p>
                <br>
                <p>1、完成销售目标；</p>
                <br>
                <p>2、维护好客户。</p>
              </div>
              <div class="claim">
                <p>任职要求：</p>
                <br>
                <p>1、全日制本科以上学历，市场营销专业优先考虑；</p>
                <br>
                <p>2、至少1年以上电话销售工作经验；</p>
                <br>
                <p>3、具有较强的沟通能力及交际技巧，具有亲和力；</p>
                <br>
                <p>4、具备一定的市场分析及判断能力，良好的客户服务意识。</p>
              </div>
            </div>
            <!--<div class="item">-->
              <!--<h4>产品经理</h4>-->
              <!--<div class="illustrate">-->
                <!--<p>岗位职责：</p>-->
                <!--<br>-->
                <!--<p>1、</p>-->
                <!--<br>-->
                <!--<p>2、</p>-->
                <!--<br>-->
                <!--<p>3、</p>-->
                <!--<br>-->
                <!--<p>4、</p>-->
                <!--<br>-->
                <!--<p>5、</p>-->
                <!--<br>-->
                <!--<p>6、</p>-->
                <!--<br>-->
                <!--<p>7、</p>-->
              <!--</div>-->
              <!--<div class="claim">-->
                <!--<p>任职要求：</p>-->
                <!--<br>-->
                <!--<p>1、</p>-->
                <!--<br>-->
                <!--<p>2、</p>-->
                <!--<br>-->
                <!--<p>3、</p>-->
                <!--<br>-->
                <!--<p>4、</p>-->
                <!--<br>-->
                <!--<p>5、</p>-->
                <!--<br>-->
                <!--<p>6、</p>-->
              <!--</div>-->
            <!--</div>-->
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import loading from '../common/loading.vue'

export default {
  name: 'join',
  data () {
    return {
      activeName2: 'first',
      msg: '加入我们',
      isLoad: true,
      // 表单
      name: '',
      company: '',
      province: '',
      city: '',
      area: '',
      address: '',
      phone: '',
      tel: '',
      email: '',
      busDetail: '',
      storeDetail: '',
      hasExp: 'Y',
      options: [{
        'areaId': '110000',
        'areaName': '北京市',
        'areaLevel': 1
      }, {
        'areaId': '120000',
        'areaName': '天津市',
        'areaLevel': 1
      }, {
        'areaId': '130000',
        'areaName': '河北省',
        'areaLevel': 1
      }],
      optionsCity: [{
        'areaId': '440100',
        'areaName': '广州市',
        'areaLevel': 2
      }, {
        'areaId': '440200',
        'areaName': '韶关市',
        'areaLevel': 2
      }, {
        'areaId': '440300',
        'areaName': '深圳市',
        'areaLevel': 2
      }, {
        'areaId': '440400',
        'areaName': '珠海市',
        'areaLevel': 2
      }, {
        'areaId': '440500',
        'areaName': '汕头市',
        'areaLevel': 2
      }],
      optionsArea: [{
        'areaId': '440103',
        'areaName': '荔湾区',
        'areaLevel': 3
      }, {
        'areaId': '440106',
        'areaName': '天河区',
        'areaLevel': 3
      }, {
        'areaId': '440111',
        'areaName': '白云区',
        'areaLevel': 3
      }]
    }
  },
  computed: {},
  mounted: function (s) {
    this.changeProvince('', 1)
    this.isLoad = false
  },
  methods: {
    submit () {
      let that = this
      that.axios.post('/store/apply/save', {
        name: that.name,
        company: that.company,
        province: that.province,
        city: that.city,
        area: that.area,
        address: that.address,
        phone: that.phone,
        tel: that.tel,
        email: that.email,
        busDetail: that.busDetail,
        storeDetail: that.storeDetail,
        hasExp: that.hasExp
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit('setToastMsg', '提交成功')
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    changeProvince (e, areaLevel) {
      let that = this
      that.axios.post('../api/sys/area/getSel', {
        areaLevel: areaLevel,
        parentId: e
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          var res = response.data.value
          if (areaLevel === 1) {
            that.options = res
            that.optionsCity = []
            that.optionsArea = []
            that.city = ''
            that.area = ''
          } else if (areaLevel === 2) {
            that.optionsCity = res
            that.optionsArea = []
            that.city = ''
            that.area = ''
          } else if (areaLevel === 3) {
            that.optionsArea = res
            that.area = ''
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    }
  },
  filters: {},
  components: {
    loading
  },
  watch: {}
}

</script>

<style scoped>
  .join {
    padding-top: 52px;
    background-color: #FFFFFF;
    padding-bottom: 80px;
    border-bottom: 1px solid #e8e8e8;
  }
  *{
    font-family: "Microsoft YaHei";
  }
.top img {
  width: 100%;
}

.content {
  width: 1200px;
  margin: 0 auto;
  padding: 100px 0 80px 0;
  text-align: left;
  font-size: 16px;
  color: #333333;
}

/*---------------加盟门店样式------------*/
/*-------------标题样式-----------*/
.title {
  margin-top: 20px;
  padding: 58px 0 10px 0;
  border-top: 1px solid #F0F0F0;
}

.title h4 {
  margin-bottom: 17px;
  font-size: 20px;
  color: #333333;
  font-family: "FZYH_510M";
}

/*-------------每行两个输入框样式------------*/
.two {
  margin-top: 42px;
  display: flex;
  justify-content: space-between;
}
.required {
  height: 50px;
  line-height: 50px;
  color: red;
  padding-right: 12px;
}
/*--------------选择省份样式-------------*/
.active {
  margin-top: 20px;
}

.active p {
  font-family: 'SourceHanSansCN-Normal';
  padding: 20px 0;
}

/*---------------按钮样式----------------*/
.submit{
  margin-top: 50px;
  background-color: #00bf73;
  color: #FFFFFF;
  width: 160px;
  padding: 10px 0;
}

/*-----------职位招聘样式-----------*/
.item {
  padding: 30px 0 10px 0;
}

.item h4 {
  margin-bottom: 8px;
}
/*.item .illustrate p{*/
  /*line-height: 25px;*/
/*}*/

.claim {
  margin-top: 30px;
}
</style>
<style>
/*-------------tab选项卡样式-----------*/
.el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

.el-tabs__nav-wrap {
  margin-bottom: 0;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  background-color: #f2f2f2;
  color: #161a1a;
  font-size: 20px;
  width: 163px;
  text-align: center;
  line-height: 60px;
  height: 60px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #00bf73 !important;
  color: #FFFFFF !important;
}

/*form表单样式*/
.el-input__inner {
  background-color: #eeeeee;
  border: none !important;
  height: 50px;
  line-height: 50px;
}

/*文本框*/
.el-textarea__inner {
  padding: 15px;
  background-color: #eeeeee;
  border: none !important;
  min-height: 100px !important;
}

.el-textarea__inner:focus {
  /*color: #00bf73;*/
}

/*-------------单选框样式------------*/
.el-radio__input.is-checked .el-radio__inner {
  border-color: #00bf73;
  background: #00bf73;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #00bf73;
}
</style>



// WEBPACK FOOTER //
// src/components/about/join.vue